export default "__VITE_ASSET__QtfyuXqb__"